import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import Home from 'pages/Home';
// import ComingSoon from "pages/ComingSoon";

export default function PageRoutes () {
    return (
        <Router>
            <Routes>
                <Route index path="/" element={<Home />} />
            </Routes>
        </Router>
    );
}
